// Spikes Gear App Index
// Routes to the appropriate Spikes Gear page based on the URL

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import OrderForm from './OrderForm';
import Fulfillment from './Fulfillment';

const SpikesGearApp = () => {
  return (
    <Routes>
      {/* Main dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="spikes-gear:read">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Order fulfillment / print checklist */}
      <Route
        path="/fulfillment"
        element={
          <ProtectedRoute requiredPermission="spikes-gear:read">
            <Fulfillment />
          </ProtectedRoute>
        }
      />

      {/* Create new order */}
      <Route
        path="/create"
        element={
          <ProtectedRoute requiredPermission="spikes-gear:write">
            <OrderForm />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/spikes-gear" replace />} />
    </Routes>
  );
};

export default SpikesGearApp;
